import { API_ROOT } from 'src/constants';
import Request, {
  setData,
  setMethod,
  setURL
} from '../index';

import SiteSettings from 'src/siteSetting';

import { Loan } from 'src/types/Loan';
import { getNamespaceName } from '../objects/namespaces';
import { pathOr } from 'ramda';


export const updateLoanAppByID = (data: Partial<any>) =>
  Request<Loan>(
    setURL(`${API_ROOT}/loanapps/${pathOr("", ["id"], data)}`),
    setMethod('PUT'),
    setData(data)
  ).then((response) => response.data);



export const getLoanAppplication = (id: string) =>
  Request<Loan>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/${id}`),
    setMethod('GET')
  ).then((response) => response.data);

export const getAdvisorMiniLoanAppsV2 = (id: string, params: any) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/v2/advisors/short/${id}`),
    setMethod('POST'),
    setData(params)
  ).then((response) => response.data);

export const getAllMiniLoanAppsV2 = (params: any) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/v2/all/short`),
    setMethod('POST'),
    setData(params)
  ).then((response) => response.data);


export const get34XMLDoc = (id: string) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/export/${id}/mismo?envelope=${SiteSettings.oneloanRunFnExportXMLEnvelop()}`),
    setMethod('GET')
  ).then((response) => response.data);


export const setLoanAppplicationPriority = (id: string, data: Partial<any>) =>
  Request<Loan>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/priority/${id}`),
    setMethod('PUT'),
    setData(data)
  ).then((response) => response.data);

/**
 * batchLoanApp is used to update batch loan app resources in single api call
 * @param id { string } loan application id 
 * @param data { object } loan app spec with loan application API resources
 * returns loan application 
*/
export const batchLoanApp = (id: string, data: any) =>
  Request<Loan>(
    setURL(`${API_ROOT}/${getNamespaceName()}/loanapps/spec/${id}`),
    setMethod('PATCH'),
    setData(data)
  ).then((response) => response.data);